import { Link } from "react-router-dom";
import { Image } from "../../AppDataType";
import useDataContext from "../../providers/DataProvider/useDataContext";

/* ========================================================================== */
interface Props {
    outsideCardImage: Image;
    outsideIndex: number;
    outsideName: string
}

const OutsideCard: React.FC<Props> = ({ outsideCardImage, outsideIndex, outsideName }) => {
    const { data } = useDataContext();

    return (
        <Link aria-label="more-info-link"
              to={ data.pages.outsidePage.route }
              state={{ outsideIndex }}
              className="flex justify-center h-full">
            <article aria-label="outside-card"
                     className="flex flex-col justify-between rounded-xl w-[550px]
                              bg-first-solid text-fifth-solid overflow-hidden
                                cursor-pointer transition-shadow duration-500 ease-out
                                hover:shadow-first-solid">
                <figure className="overflow-hidden">
                    <img src={outsideCardImage.src}
                         alt={outsideCardImage.alt}
                         className="transition-transform duration-500 ease-out hover:scale-110"
                         loading="lazy"/>
                </figure>

                <button className="bg-first-solid text-base px-5 py-3
                                     transition-colors duration-500 ease-out 
                                   hover:bg-third-solid hover:text-first-solid">
                    { outsideName }
                </button>
            </article>
        </Link>
    )
}

export default OutsideCard;
